var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgJames = function SvgJames(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 203.2 140.7",
    style: {
      enableBackground: "new 0 0 203.2 140.7"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.6,9.7h4.7l28.2,65.2h0.2l28.4-65.2h14.3v83.2h-9.9V23.1h-0.2l-29.8,69.8h-6l-29.8-69.8L104.6,9.7z M101.4,106.4V9.6 h-10v96.8c0,8.3-6.8,15.1-15.1,15.1H21.7v10h54.7C90.2,131.5,101.4,120.2,101.4,106.4z M180.5,97.7h-75.9v10h75.9V97.7z M65.8,46.2 c-8-1-11.4,5-11.4,5s-3.5-6-11.4-5c-6.6,0.8-8.4,7.5-8.4,12c0,12.3,12.8,18,19.8,25.1c7-7.1,19.8-12.8,19.8-25.1 C74.1,53.8,72.4,47,65.8,46.2z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgJames, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/james.ed271469.svg";
export { ForwardRef as ReactComponent };